import type { ReactNode } from "react";
import { colors, fontSize } from "../lib/tokens";

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <div style={{ padding: "48px 16px", textAlign: "center", color: colors.stone, fontSize: fontSize.md }}>
      {children}
    </div>
  );
}
